import { api_get, api_post } from "api/utils"

const PaymentAPI = {
    //    load: _loadPayment,
    list: _loadPaymentList,
    convertTaskToCredits: _convertTaskToCredits,
};


// async function _loadPayment(key: string) {
//     // Autogenerated
//     if (!key) {
//         return null;
//     }
//     return api_get("/payment/" + key).then((res) => {
//         if (!res.ok) {
//             return null;
//         }
//         else {
//             return res.json();
//         }
//     });
// }


async function _loadPaymentList(userUuid : "", cursor: string) {
    let url = '/payment/list?';
    if(userUuid) {
        url += 'user_uuid=' + userUuid + '&';
    }
    if (cursor) { url += 'cursor=' + cursor; }
    return api_get(url).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}


async function _convertTaskToCredits() {
    return api_post('/payment/convert-task-to-credits',
        {
        })
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
            else {
                throw await res.json();
            }
        });
}

export default PaymentAPI;
